import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import FooterLegalNavigation from './FooterLegalNavigation';
import { palette, spaces } from '../../assets/styles/themes/tokens';
import { externalLinks } from '../../constants';

interface LoginFooterProps {
  isSmallScreen: boolean;
}

const LoginFooter = ({ isSmallScreen }: LoginFooterProps) => {
  const { t } = useTranslation();

  return (
    <Box
      className='login-page-footer'
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection:  isSmallScreen ? 'column' : 'row',
          marginBottom: isSmallScreen ? 0 : spaces.xxxl,
        }}
      >
        <Typography
          data-testid='no-account'
          variant='body1'
          color={palette.text.secondary}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: isSmallScreen ? spaces.xs : spaces.md,
            marginBottom: isSmallScreen ? spaces.xs : spaces.md,
            marginRight: isSmallScreen ? spaces.xs : spaces.lg,
          }}
        >
          {t('Don\'t have an account yet?')}
        </Typography>
        <Button
          data-testid='register-button'
          variant='text'
          size='large'
          color='secondary'
          sx={{
            paddingX: spaces.xs,
            paddingY: spaces.xxs,
            '&:hover': {
              backgroundColor: palette.action.hover,
              color: palette.secondary.main,
            },
          }}
          href={externalLinks.register}
        >
          {t('Test now')}
        </Button>
      </Box>
      <FooterLegalNavigation isSmallScreen={isSmallScreen} />
    </Box>
  );
};

export default LoginFooter;
